import React, { useState } from 'react';

const ImageSlider = ({ post, config }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isZoomed, setIsZoomed] = useState(false);

    const images = post.photopath || [];

    const handleImageClick = () => {
        setIsZoomed(true);
    };

    const closeZoom = () => {
        setIsZoomed(false);
    };

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const goToImage = (index) => {
        setCurrentImageIndex(index);
    };

    if (images.length === 0) {
        return <div>No images available</div>;
    }

    const currentImageSrc = config.API + "/images/user/" + images[currentImageIndex];

    return (
        <div className="image-slider-container">
            {/* Main Image Display */}
            <div className="flex-item" style={{ textAlign: 'center', position: 'relative' }}>
                <img
                    onClick={handleImageClick}
                    style={{
                        // marginTop: "15px",
                        width: '100%',
                        height: '550px',
                        cursor: "pointer",
                        objectFit: "cover",
                    }}
                    src={currentImageSrc}
                    alt={`Profile ${currentImageIndex + 1}`}
                />

                {/* Navigation Arrows - Only show if more than 1 image */}
                {images.length > 1 && (
                    <>
                        <button
                            onClick={prevImage}
                            style={{
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            &#8249;
                        </button>

                        <button
                            onClick={nextImage}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            &#8250;
                        </button>
                    </>
                )}

                {/* Image Counter */}
                {images.length > 1 && (
                    <div style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        color: 'white',
                        padding: '5px 10px',
                        // borderRadius: '15px',
                        fontSize: '12px'
                    }}>
                        {currentImageIndex + 1} / {images.length}
                    </div>
                )}
            </div>
            <span style={{ fontSize: '16px' }}>
                No. of Images available - {images.length > 1 ? `${currentImageIndex + 1} / ${images.length}` : images.length}
            </span>

            {/* Thumbnail Navigation */}
            {/* {images.length > 1 && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    marginTop: '15px',
                    flexWrap: 'wrap'
                }}>
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={config.API + "/images/user/" + img}
                            alt={`Thumbnail ${index + 1}`}
                            onClick={() => goToImage(index)}
                            style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                border: currentImageIndex === index ? '3px solid #007bff' : '2px solid transparent',
                                opacity: currentImageIndex === index ? 1 : 0.7,
                                transition: 'all 0.3s ease'
                            }}
                        />
                    ))}
                </div>
            )} */}

            {/* Zoom Modal */}
            {isZoomed && (
                <div
                    onClick={closeZoom}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div style={{ position: 'relative' }}>
                        <img
                            src={currentImageSrc}
                            alt="Zoomed Profile"
                            style={{
                                maxHeight: '90vh',
                                maxWidth: '90vw',
                                // borderRadius: '10px',
                                boxShadow: '0 0 15px white',
                                backgroundColor: 'white'
                            }}
                        />

                        {/* Navigation in zoom mode */}
                        {images.length > 1 && (
                            <>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        prevImage();
                                    }}
                                    style={{
                                        position: 'absolute',
                                        left: '-60px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        color: 'black',
                                        border: 'none',
                                        // borderRadius: '50%',
                                        width: '50px',
                                        height: '50px',
                                        cursor: 'pointer',
                                        fontSize: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    &#8249;
                                </button>

                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        nextImage();
                                    }}
                                    style={{
                                        position: 'absolute',
                                        right: '-60px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        color: 'black',
                                        border: 'none',
                                        // borderRadius: '50%',
                                        width: '50px',
                                        height: '50px',
                                        cursor: 'pointer',
                                        fontSize: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    &#8250;
                                </button>
                            </>
                        )}

                        {/* Close button */}
                        <button
                            onClick={closeZoom}
                            style={{
                                position: 'absolute',
                                top: '-15px',
                                right: '-15px',
                                backgroundColor: 'white',
                                color: 'black',
                                border: 'none',
                                // borderRadius: '50%',
                                width: '30px',
                                height: '30px',
                                cursor: 'pointer',
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold'
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImageSlider;
